import React, {useEffect} from 'react';
import {BrowserRouter as Router, Switch} from 'react-router-dom';
import MainLayout from '@app/modules/layouts/Main';
import Register from '@modules/register';
// import Login from '@modules/login/Login';
import AzureSignIn from '@modules/login/AzureSignIn';
import AzurePage from '@app/pages/AzurePage';
import UserNotFound from '@app/pages/UserNotFound';
import ReporterDashboard from '@pages/ReporterDashboard';

import {useWindowSize} from '@app/hooks/useWindowSize';
import {calculateWindowSize} from '@app/utils/helpers';
import {useDispatch, useSelector} from 'react-redux';
import {setWindowSize} from '@app/modules/layouts/redux';

import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';

import './App.scss';

const App = () => {
  const windowSize = useWindowSize();
  const screenSize = useSelector((state) => state.layout.screenSize);
  const dispatch = useDispatch();

  useEffect(() => {
    const size = calculateWindowSize(windowSize.width);
    if (screenSize !== size) {
      dispatch(setWindowSize(size));
    }
  }, [windowSize]);

  return (
    <Router>
      <Switch>
        <PublicRoute exact path="/register/:uuid">
          <Register />
        </PublicRoute>
        <PublicRoute exact path="/login">
          <AzureSignIn />
        </PublicRoute>

        <PrivateRoute exact path="/reporter">
          <ReporterDashboard />
        </PrivateRoute>

        <PublicRoute exact path="/azure-test">
          <AzurePage />
        </PublicRoute>

        <PublicRoute exact path="/user/notfound">
          <UserNotFound />
        </PublicRoute>

        <PrivateRoute path="/">
          <MainLayout />
        </PrivateRoute>

        {/* <PrivateRoute path="/">
                    <MainLayout />
                </PrivateRoute> */}
      </Switch>
    </Router>
  );
};

export default App;
